/**
 * The `ch-grid-actionbar` component represents a container for a grid actions.
 */
export class ChGridActionbar {
    el;
    static get is() { return "ch-grid-actionbar"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-grid-actionbar.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-grid-actionbar.css"]
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-grid-actionbar.js.map
